var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-html",style:({ padding: _vm.isDesktop ? '15px 30px !important' : '12px 15px !important' })},[_c('v-flex',{staticClass:"ql-editor ql-blank",attrs:{"xs12":""},domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }